import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';

import { ActionSectionContent } from '~/src/features/payments-abn/styled';

export const TypeContent = styled(ActionSectionContent)<{ isLoading?: boolean }>`
    flex-direction: row;
    flex-wrap: nowrap;
    column-gap: 8px;

    @media (max-width: ${wideBreakpoints.tablet}) {
        column-gap: ${p => p.isLoading ? '8px' : 0};
    }
`;

export const TypeWrapper = styled.div`
    width: 340px;
    height: 236px;

    @media (max-width: ${wideBreakpoints.laptop}) {
        width: 306px;
        height: 236px;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        width: 370px;
        height: 128px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        width: 190px;
        height: 172px;
    }
`;
